import { context } from '@porterin/booking-flow/src/auth/view/contexts/auth-content/AuthContentContext';
import { AuthContentVM } from '@porterin/booking-flow/src/auth/view-model/auth-content/AuthContentVM';
import React from 'react';

export const AuthContentProvider = ({
  value,
  children,
}: {
  value: AuthContentVM;
  children: React.ReactNode;
}) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
